import { Node, mergeAttributes } from '@tiptap/core';

export const CharacterName = Node.create({
  name: 'characterName',
  group: 'block',
  content: 'inline*',

  parseHTML() {
    return [{ tag: 'p[data-type="character-name"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'character-name',
        class: 'play-character-name',
        spellcheck: 'false',
      }),
      0,
    ];
  },
});
